import CreateEditSaleForm from './CreateEditSaleForm';

export default CreateEditSaleForm;